import service from "@/store/services/tareas-service";

const state = {
  list: {},
  tarea: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, tarea) => {
    state.tarea = tarea;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((tarea) => {
      commit("SET_RESOURCE", tarea);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((tarea) => {
      commit("SET_RESOURCE", tarea);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((tarea) => {
      commit("SET_RESOURCE", tarea);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  tarea: (state) => state.tarea,
  dropdown: (state) => {
    state.list.map((tarea) => console.log(tarea));
    return state.list.map((tarea) => ({
      id: tarea.id,
      alias: tarea.alias,
    }));
  },
};

const tareas = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default tareas;
